<template>
  <!-- 答题须知 -->
  <div>
  <div class="headbt">
    <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>答题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </div>

  <!-- 开始答题 -->
  <div class="cards_a">
    <div class="rw-info">
      <div class="rw-flag"></div>
      <div class="rw-title">{{title}}</div>
     <!-- <div class="rw-back" @click="back"><i class="el-icon-back"></i>返回</div> -->
    </div>
    <div class="content">
      <div class="wt-box">
        <div class="wt-title">{{index+1}}、{{list[index].subject}}</div>
        <div class="wt-jsjs">
          <div style="width: 70%;">已答：<span style="color: red;">{{askindex}}</span>/{{total}}</div>
          <div style="float: right;">用时：<span style="color: rgb(21, 183, 185);">{{yongshi}}</span></div>
        </div>
      </div>
      <el-progress :percentage="jdt" :show-text="false"></el-progress>
      <div>
        <el-radio-group v-model="value" @change="answer">
          <div class="wt-option" v-for="(item,index2) in list[index].options" :key="index2">
            <el-radio :label="item.id">{{option_tag[index2]}}：{{item.key}}
            </el-radio>
            </div>
        </el-radio-group>
      </div>
      <div>
        <el-button class="next-btn" :class="[this.index == 0?'jy_class':'']" type="primary" size="mini" @click="up">上一题</el-button>
        <el-button class="next-btn" :class="[this.index == total-1?'jy_class':'']" type="primary" size="mini" @click="down">下一题</el-button>
        <el-button class="next-btn" type="primary" size="mini" @click="subjg" v-show="askindex == total">提交评测结果</el-button>
      </div>
      <div style="margin-top: 30px;margin-left: 30px;"><el-checkbox v-model="next_auto" :true-label="1" :false-label="0">答完自动下一题</el-checkbox></div>
      <div>
        <div style="font-weight: bold;font-size: 16px;padding-left: 10px;margin-top: 20px;margin-bottom: 20px;">已答题预览:</div>
        <div class="ydtyl">
          <div class="ydtyl-item" :class="active_color(index)" v-for="(item,index) in list" :key="index" @click="change_item(index)">{{index+1}}</div>
        </div>
      </div>
      </div>
    </div>
</div>
</template>

<script>
  import { lbdetailedList,dati } from '../../api/baseset.js'
  export default {
    data() {
      return {
        step: 0,
        rwinfo: {},
        lbinfo: {},
        list: [{subject:''}],
        askindex: 0,
        index: 0,
        total: 0,
        time: 0,
        value: '',
        next_auto: 1,
        jglist: [],
        idlist: [],
        jglabs: [],
        option_tag: ['A','B','C','D','E','F'],
        title:'',
        taskid:'',
        lbid:''

      }
    },
    created() {
      this.init();
    },
    computed: {
      yongshi() {
        var minutes = Math.floor((this.time % 3600) / 60);
        var seconds = this.time % 60;
        if(minutes < 10) {
          minutes = '0'+minutes;
        }
        if(seconds < 10) {
          seconds = '0'+seconds;
        }
        return minutes+':'+seconds;
      },
      jdt() {
        if(this.total > 0){
          return (this.askindex/this.total).toFixed(2) * 100;
        }else{
          return 0;
        }
      }
    },
    methods:{
      init() {


        let cache = JSON.parse(localStorage.getItem("profileData"))

        this.taskid =cache.rwid
        this.lbid =cache.lbid
        this.title = cache.title
        let datiinfo = localStorage.getItem(this.taskid+"_"+this.lbid+"_"+"datiinfo");
        if(datiinfo ){
          datiinfo = JSON.parse(datiinfo);
          this.step = datiinfo.step;
          this.rwinfo = datiinfo.rwinfo;
          this.lbinfo = datiinfo.lbinfo;
          this.list = datiinfo.list;
          this.askindex = datiinfo.askindex;
          this.index = datiinfo.index;
          this.total = datiinfo.total;
          this.time = datiinfo.time;
          this.value = datiinfo.value;
          this.next_auto = datiinfo.next_auto;
          this.jglist = datiinfo.jglist;
          this.jglabs = datiinfo.jglabs;
          this.idlist = datiinfo.idlist;
          this.option_tag = datiinfo.option_tag;
          this.jishi();
        }else{
          // let cache = JSON.parse(this.$store.state.cache);
          // this.rwinfo = cache.rwinfo;
          // this.lbinfo = cache.lbinfo;
          this.getData();
          this.jishi();
        }
        // this.getData();
      },
      getData() {
      let that = this;

        lbdetailedList({gaugeId:this.lbid}).then(res => {

          if(res.code = 200) {
            that.list = res.data;
            that.total = res.data.length;
          }
        })
      },
      jishi(){
        let that = this;
        setInterval(function(){
          that.time++;
        },1000);
      },
      ksdt() {
        this.step = 1;
        this.jishi();
      },
      back() {
        this.$router.go(-1);
      },
      answer() {
        if(this.next_auto == 1){
          this.wthd();
          let that = this;
          setTimeout(function(){
            that.down();
          },200);
        }else{
          this.wthd();
        }
      },
      wthd() {
        if(this.jglist.length <= this.total){
          this.jglist[this.index] = this.value;
          for(let i=0;i<this.list[this.index].options.length;i++){
            if(this.list[this.index].options[i].id != undefined){
              if(this.list[this.index].options[i].id == this.value){
                this.idlist[this.index] = this.value;
                this.jglist[this.index] = this.list[this.index].options[i].value;
                this.jglabs[this.index] = this.list[this.index].options[i].key;
              }
            }else{
              if(this.list[this.index].options[i].value == this.value){
                this.jglabs[this.index] = this.list[this.index].options[i].key;
              }
            }
          }
          this.askindex = this.jglist.length;
          this.value = this.jglist[this.index];
          this.cache();
        }
      },
      cache() {
        localStorage.setItem(this.taskid+"_"+this.lbid+"_"+"datiinfo", JSON.stringify(this.$data));
      },
      up() {
        if(this.index > 0){
          this.index--;
          this.value = this.jglist[this.index];
          if(this.idlist[this.index] != undefined){
            this.value = this.idlist[this.index];
          }
        }
      },
      down() {
        if(this.index < this.total - 1 && this.index < this.askindex){
          this.index++;
          this.value = this.jglist[this.index];
          if(this.idlist[this.index] != undefined){
            this.value = this.idlist[this.index];
          }
        }
      },
      active_color(num){
        if(num == this.askindex){
          return 'dq_state';
        }else if(num < this.askindex){
          return 'yd_state';
        }else{
          return '';
        }
      },
      change_item(index){
        if(index <= this.askindex){
          this.index = index;
          this.value = this.jglist[index];
          if(this.idlist[this.index] != undefined){
            this.value = this.idlist[this.index];
          }
        }
      },
      subjg() {
        localStorage.removeItem('datiinfo');
        let param = []
        for(let i=0;i<this.list.length;i++){
          let hd = {taskId:this.taskid,option:this.jglabs[i],optionValue:this.jglist[i],gaugeId:this.lbid,detailedId:this.list[i].id}
          param.push(hd);
        }
        let that = this;
       // console.log(param)
       //return
        dati(param).then(res => {
          if(res.code == 200){
            that.$message({
              type: 'success',
              message: '提交成功'
            });
            this.$router.push("/user/wdcpdetail2/"+this.lbid+'/'+this.taskid+"/"+this.title);
          }else{
            that.$message.error(res.msg);
          }
        })
      },
      fh(){
        //clearInterval(intervalId);
       window.history.go(-1);
      },
      wrtiecache(state){ //1 写入缓存 0 清空缓存
          if(state == 0){
               localStorage.removeItem(this.bl);
          }else{
            this.hc.current_show = this.current_show
            this.hc.current_ti = this.current_ti
            this.hc.bfb = this.bfb
            this.hc.dtxx = this.dtxx
            this.hc.last_ti_active = this.last_ti_active
            this.hc.rwtj = this.rwtj
            this.hc.ydt = this.ydt
            this.hc.first_ti_active = this.first_ti_active
            this.hc.second = this.second
            this.hc.formdata2 = this.formdata2
            localStorage.setItem(this.bl, JSON.stringify(this.hc))

          }

      },
    }
  }
</script>

<style scoped>
  .box-card{width: 96%;margin: auto;}
  .rw-info{display: flex;font-size: 15px;line-height: 50px;min-width: 600px;}
  .rw-flag{width: 5px;height: 25px;border-radius: 3px;background-color: #00DDA3;margin-right: 10px;margin-top: 14px;}
  .rw-title{width: 65%;margin-top:14px;line-height: 24px;font-size: 14px;font-weight: bold;color: black;}
  .rw-back{width: 7%;color: #00DDA3;text-align: right;}
  .tip{font-size: 18px;color: #333;}
  .rw_disc{color: #666;margin-top: 20px;font-size: 15px;line-height: 26px;}
  .container {display: flex;justify-content: center;margin-top: 100px;}
  /* .content{min-height: 400px;font-size: 15px;color: #333;border: solid 1px #ddd;margin: 20px;} */
  .content{min-height: 400px;font-size: 14px;color: #333;border: solid 1px #ddd;width: 100%;margin-top: 10px; }
  .wt-box{height: auto;background-color: aliceblue;font-size: 14px;}
  .wt-title{width: 100%;font-size: 14px;text-indent: 15px;height: auto;min-height: 35px;line-height: 35px;}
  .wt-jsjs{width: 100%;line-height: 30px;display: flex;font-size: 13px;text-indent: 12px;}
  .wt-option{margin-top: 10px;font-size: 14px;padding-left: 30px;}
  .next-btn{margin-top: 50px;margin-left: 30px;}
  .ydtyl{display: flex;flex-wrap: wrap;}
  .ydtyl-item{width: 22px;height: 22px;line-height: 22px;border-radius: 3px;background-color: #999;margin-left: 5px;text-align: center;color: #ffffff;margin-bottom: 5px;cursor: pointer;}
  .yd_state{background-color:#00DDA3;}
  .dq_state{background-color: #ffae3b;}
  .jy_class{background-color: #999!important;border: #999!important;}
  /deep/ .el-radio__label{font-size: 14px;}
  /deep/ .el-progress-bar__inner{background-color: #00DDA3;}
  /deep/ .el-button--primary{background-color:#00DDA3;border: #00DDA3;}
  .lb-optons-box{width: 96%;margin: 20px auto;border: solid 1px #ddd;}
  .lb-optons-hr{width: 100%;display: flex;line-height: 40px;font-weight: bold;border-bottom: solid 1px #ddd;}
  .lb-optons{width: 100%;display: flex;line-height: 40px;}
  .lb-optons-left{width: 65%;border-right: solid 1px #ddd;text-indent: 10px;}
  .lb-optons-right{width: 30%;display: flex;}
  .lb-optons-right-item{width: 50%;text-align: center;}
  .cards_a{padding: 5px;background-color: white;margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/user/datia1.vue